module.exports = __webpack_public_path__ + "static/media/instagram.de6aae61.svg";